<template>
  <div :class="{ 'inline-block': ['advertiser_source_id'].includes(formKey)}">
    <!-- 模板来源 -->
    <div v-if="formKey === 'advertiser_source_id'" class="ml-10">
      <el-button :loading="loading" type="success" @click="onPull(formItem)">同步</el-button>
    </div>
  </div>
</template>

<script>export default {
  props: {
    // 页面配置
    pageConfig: {
      type: Object,
      required: true,
    },
    // 表单项键名
    formKey: {
      type: String,
      required: true,
    },
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 按钮loading
      loading: false,
    };
  },
  methods: {
    /**
     * 同步
     * @param {Object} form_item 表单项
     * @returns {void}
     */
    onPull(form_item) {
      this.loading = true;
      const { params = {}} = form_item;
      const { channel_interface, pullAdvertiserSourceApi } = this.pageConfig;
      pullAdvertiserSourceApi({
        channel_interface,
        ...params,
      }).then(async({ message }) => {
        form_item.options = await this.getAdvertiserSourceList(params);
        this.$message.success(message || '同步成功！');
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 获取模板来源列表
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getAdvertiserSourceList(params) {
      const { channel_interface, getAdvertiserSourceApi } = this.pageConfig;
      return new Promise((resolve, reject) => {
        getAdvertiserSourceApi({
          channel_interface,
          ...params,
        }).then(({ list = [] }) => {
          const result = list.map(({ id, name }) => ({ label: name, value: id }));
          resolve(result);
        }).catch(reject);
      });
    },
  },
};
</script>
